import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';

interface ErrorDisplayProps {
  error: string | null;
  onRetry?: () => void;
  severity?: 'error' | 'warning' | 'info' | 'success';
  title?: string;
}

/**
 * A reusable component for displaying error messages
 */
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onRetry,
  severity = 'error',
  title
}) => {
  if (!error) return null;

  return (
    <Box my={2}>
      <Alert 
        severity={severity}
        action={
          onRetry ? (
            <Button color="inherit" size="small" onClick={onRetry}>
              Retry
            </Button>
          ) : undefined
        }
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {error}
      </Alert>
    </Box>
  );
};

export default ErrorDisplay;
